<script>
    import { fade, fly } from 'svelte/transition';
    import { flip } from 'svelte/animate';
    import { toast } from './stores.js';
    import ToastItem from './ToastItem.svelte';
    import themeColors from '$config/theme-colors.json';

    /** @type {import('./stores.js').SvelteToastOptions} */
    export let options = {};
    /** @type {(string|'default')} */
    export let target = 'default';

    /** @type {import('./stores.js').SvelteToastOptions[]} */
    let items = [];

    /** @param {import('./toast-types').ToastTheme} [theme] */
    function getCss(theme) {
        let css = '';

        switch (theme) {
            case 'warning':
                css = `--toastColor: ${themeColors['prevent-primary-text']};--toastBackground: ${themeColors['prevent-yellow-contrast']};--toastBarBackground: ${themeColors['prevent-primary-text']}`;
                break;
            case 'danger':
                css = `--toastColor: white;--toastBackground: ${themeColors['prevent-red-contrast']};--toastBarBackground: ${themeColors['prevent-primary-text']}`;
                break;
            case 'success':
                css = `--toastColor: white;--toastBackground: ${themeColors['prevent-primary-green'][100]};--toastBarBackground: ${themeColors['prevent-primary-darker-green'][100]}`;
                break;
            case 'info':
            default:
                css = `--toastColor: white;--toastBackground: ${themeColors['prevent-secondary-dark-blue'][100]};--toastBarBackground: ${themeColors['prevent-secondary-light-blue'][100]}`;
                break;
        }

        return css;
    }

    $: toast._init(target, options);

    $: items = $toast.filter((i) => i.target === target);
</script>

<ul class="_toastContainer">
    {#each items as item (item.id)}
        <li
            class={item.classes?.join(' ')}
            in:fly={item.intro}
            out:fade
            animate:flip={{ duration: 200 }}
            style={getCss(item.theme)}>
            <ToastItem {item} />
        </li>
    {/each}
</ul>
